import { lazy, Suspense } from 'react';

import { useFreePassEnabled } from '@/features/free-pass';

const StreakSheet = lazy(() => import('@/components/StreakSheet'));
const StreakCelebration = lazy(() => import('@/components/StreakCelebration'));

const StreakSurfaces = () => {
  const enabled = useFreePassEnabled();
  if (!enabled) return null;

  return (
    <Suspense fallback={null}>
      <StreakSheet />
      <StreakCelebration />
    </Suspense>
  );
};

export default StreakSurfaces;
